import { Badge } from "@/components/ui/badge/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Activity, ClipboardCheck, History, Microscope } from "lucide-react";

export default function BioanalistaPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Bioanálisis
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Panel dedicado para el procesamiento y validación de muestras biológicas.
          </p>
        </div>
        <Button className="w-full sm:w-auto">
          <Microscope className="h-4 w-4 mr-2" />
          Procesar Nueva Muestra
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
        <Card className="lg:col-span-3">
          <CardHeader>
            <CardTitle>Cola de Trabajo</CardTitle>
            <CardDescription>Muestras pendientes por procesar y validar.</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-primary-50 dark:bg-primary-900/20 rounded-full">
                      <Activity className="h-4 w-4 text-primary-600" />
                    </div>
                    <div>
                      <p className="font-medium text-sm text-gray-900 dark:text-gray-100">
                        Muestra #M00{i}
                      </p>
                      <p className="text-xs text-gray-500">
                        Hematología Completa • Paciente Prueba {i}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <Badge variant={i % 2 === 0 ? "secondary" : "default"}>
                      {i % 2 === 0 ? "En proceso" : "Pendiente"}
                    </Badge>
                    <Button size="sm" variant="outline">
                      Validar
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <div className="space-y-4">
          <Card>
            <CardHeader className="p-4">
              <CardTitle className="text-base flex items-center gap-2">
                <ClipboardCheck className="h-4 w-4 text-green-600" />
                Resumen Diario
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 pt-0">
              <div className="text-2xl font-bold">24</div>
              <p className="text-xs text-gray-500">Muestras validadas hoy</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="p-4">
              <CardTitle className="text-base flex items-center gap-2">
                <History className="h-4 w-4 text-amber-600" />
                Histórico
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 pt-0">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                Ver registros anteriores de bioanálisis.
              </p>
              <Button variant="outline" className="w-full text-xs h-8">
                Ver todo
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
